import types from './types';

export default ({ data, type }) => {
  switch (type) {
    case types.RESUME_FAILURE:
      return {
        title: 'Could not resume triggers',
        message: data.message,
        type: 'error'
      };
    case types.TRIGGER_FAILURE:
      return {
        title: 'Could not trigger job',
        message: data.message,
        type: 'error'
      };
    case types.STOP_FAILURE:
      return {
        title: 'Could not stop Job',
        message: data.message,
        type: 'error'
      };
    default:
      return false;
  }
};
